/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/8/2022
 */

export const QwoachFileType = Object.freeze({
	DRIVE_FILE: "drive_file",
	LINK: "link",
	FORM: "form",
	LEGAL_DOC: "legal_doc",
	LEGAL_DOC_TEMPLATE: "legal_doc_template"
})
